module.exports = __webpack_public_path__ + "static/4976fad42b2b369d980ced99c78a7aaef10a603a1403c824b9adff4e77c2e0ca-39c07a3aae47fc18b2ee37285adf5ec6.jpeg";